import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import FlowsActive from './FlowsActive';

const FlowsActiveBridge = react2angular(FlowsActive, ['backFromState']);

export default FlowsActiveBridge;
